import { TermsDataType } from '@/types/terms.type';

export const personalInfoProcessingData: TermsDataType[] = [
  {
    title: '개인정보처리방침\n\n',
    discription1:
      '도로로(이하 ‘회사’라고 합니다.)는 고객의 개인정보보호를 위하여 「개인정보보호법」 및 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」을 준수하고 있습니다. 이에, 「개인정보보호법」 제 30조에 따라 정보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련된 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립 ‧ 공개합니다.',
    lineBreak: true,
  },
  {
    title1: '목차',
    discription2: [
      ['1.', '개인정보의 처리목적, 수집 및 이용 항목, 보유 및 이용기간'],
      ['2.', '14세 미만 아동의 개인정보 처리에 관한 사항'],
      ['3.', '개인정보의 파기 절차 및 방법에 관한 사항'],
      ['4.', '개인정보의 제 3자 제공에 관한 사항'],
      ['5.', '개인정보 처리업무의 위탁에 관한 사항'],
      ['6.', '개인정보의 안전성 확보조치에 관한 사항'],
      ['7.', '개인정보 자동 수집 장치의 설치・운영 및 그 거부에 관한 사항'],
      ['8.', '행태정보의 수집·이용 및 거부에 관한 사항'],
      ['9.', '이용자의 권리와 그 행사방법'],
      ['10.', '개인정보 보호책임자 및 담당부서'],
      ['11.', '개인위치정보의 처리'],
      ['12.', '정보주체의 권익침해에 대한 구제방법'],
      ['13.', '개인정보 처리방침의 변경'],
    ],
    lineBreak: true,
  },
  {
    title1: '1. 개인정보의 처리목적, 수집 및 이용 항목, 보유 및 이용기간',
    discription1:
      '회사는 「개인정보 보호법」에 따라 서비스 제공을 위해 필요 최소한의 범위에서 개인정보를 수집・이용합니다.',
  },
  {
    discription1:
      '① 회사가 보유하고 있는 개인정보의 처리목적, 보유기간, 처리하는 개인정보의 항목은 다음과 같습니다.\n' +
      '② 처리하고 있는 개인정보는 다음 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다',
    lineBreak: true,
  },
  {
    discription1: '1)정보주체의 동의 및 계약의 이행 과정에서 수집한 정보',
  },
  {
    table: {
      headers: [
        { title: '운영 근거' },
        { title: '서비스(구분)' },
        { title: '처리목적' },
        { title: '수집∙이용 항목' },
        { title: '보유 및 이용기간' },
      ],
      rows: [
        {
          cells: [
            {
              value: '개인정보 보호법 제15조제1항 제4호(“계약의 이행”)',
              rowSpan: 7,
            },
            {
              value: '본인확인(공통)',
            },
            {
              value: '본인 인증 식별',
            },
            {
              value:
                '[필수] 이름, 성별, 생년월일(주민 등록번호 앞7자리), 내/외국인 정보, 이동통신사, 휴대폰번호, 암호화된 동일인 식별정보(CI), 중복가입정보(DI)',
            },
            {
              value: '본인인증 기관에 전달 후 즉시 파기',
            },
          ],
        },
        {
          cells: [
            {
              value: '도로로 회원가입(공통)',
            },
            {
              value: '회원가입 및 관리',
            },
            {
              value:
                '[필수] ID, PW, 이름, 생년월일, 성별, 내국인여부, 이메일 주소, 통신사, 휴대전화번호, 암호화된 동일인 식별정보(CI), 중복가입 확인정보(DI)',
            },
            {
              value: '회원 탈퇴시 지체없이 파기',
            },
          ],
        },
        {
          cells: [
            {
              value: '운전면허등록(공통)',
            },
            {
              value: '운전자격확인용 운전면허 검증, 운전면허정보 등록',
            },
            {
              value:
                '[필수] 운전면허정보(면허종류, 면허번호, 적성검사 만료일, 발급일)\n' +
                '(※ 운전면허증 촬영 시 스캔된 텍스트 정보만 저장)',
            },
            {
              value: '회원 탈퇴시 지체없이 파기',
            },
          ],
        },
        {
          cells: [
            { value: '카드 등록(공통)' },
            {
              value: '회원정보와 카드 소유주 일치여부 검증을 위한 본인인증',
            },
            {
              value: '[필수] 이름, 생년월일, 내/외국인, 성별, 휴대전화번호',
            },
            {
              value: '본인인증 기관에 전달 후 즉시 파기',
            },
          ],
        },
        {
          cells: [
            {
              value: '운전연수 예약(공통)',
              rowSpan: 3,
            },
            {
              value:
                '카드 등록 편의 제공, 서비스 이용을 위한 결제카드 정보 등록',
            },
            {
              value:
                '[필수] 카드사, 카드종류, 카드번호, 유효기간, 생년월일, 암호화된 카드 식별정보(Key), 카드 BIN번호, 카드번호 끝 4자리\n' +
                '(※ 단, 결제카드 정보는할인혜택 등의 서비스 제공을 위해 카드BIN 번호 및 끝 네자리 번호만 보관하고, 해당하는 PG사에서 회신 받은 암호화된 카드 식별정보(Key)로 관리)',
            },
            {
              value: '회원 탈퇴 시 지체없이 파기',
            },
          ],
        },
        {
          cells: [
            { value: '운전연수 서비스 이용 계약 체결, 차량 예약 정보 관리' },
            {
              value:
                '[필수] 예약내역, 결제내역, 차량 운행/위치 정보,(동승운전자 등록 시)동승운전자 정보, 운전점수\n' +
                '(※ 단, 결제카드 정보는 할인혜택 등의 서비스 제공을 위해 카드BIN 번호 및 끝 네자리 번호만 보관하고, 해당하는 PG사에서 회신받은 암호화된 카드식별정보(Key)로 관리)',
            },
            {
              value: '계약 종료일로부터 5년(전자상거래법)',
            },
          ],
        },
        {
          cells: [
            { value: '운전면허 유효성 검증' },
            {
              value:
                '[필수] 운전면허정보(이름, 면허종류, 면허주소, 적성검사 만료일, 발급일)',
            },
            {
              value: '도로교통공단에 운전면허 정보 전송 후 파기',
            },
          ],
        },
        {
          cells: [
            {
              value: '개인정보 보호법 제15조 제1항 제4호(‘계약의 이행’)',
              rowSpan: 2,
            },
            {
              value: '사고 접수 및 상담(공통)',
            },
            {
              value:
                '사고 발생 시 사고 접수 및 고객 상담, 원인 규명 및 처리, 보험 접수',
            },
            {
              value:
                '[필수] 사고접수내역(서비스 이용내역, 음성정보(녹취)) 상담과정에서 정보주체가 기재/제공한 항목, 사고처리를 위한 회원정보(회원ID, 이름, 생년월일, 성별, 휴대전화번호, 이메일주소)',
            },
            {
              value: '보험 서비스 제공 후 관계법령에 따른 보유 시 까지',
            },
          ],
        },
        {
          cells: [
            { value: '고객센터 상담(공통)' },
            { value: '서비스 이용 및 상담' },
            {
              value:
                '[필수] 서비스 이용내역, 음성정보(녹취), 상담과정에서 정보주체가 기재/제공한 항목, (해당 시)예금주, 은행, 계좌번호',
            },
            { value: '3년(전자상거래법/소비자분쟁)' },
          ],
        },
      ],
    },
  },
  {
    discription1: `회사는 사고발생시 사고원인 규명과 사고의 신속한 처리 및 '자동차' 및 부속품 도난/손괴 처리를 위한 정보(증거) 수집과 사고원인 규명을 위하여 차량 내부에 차량용 블랙박스를 통하여 자동차의 주행 영상정보(정차 중인 경우 포함/음성은 포함하지 않음)을 촬영하여 녹화할 수 있습니다.`,
    lineBreak: true,
  },
  {
    discription1:
      '2)서비스 이용 과정이나 서비스 제공 업무 처리 과정에서의 자동 수집 및 생성',
  },
  {
    discription2: [
      [
        '●',
        'IP Address, 쿠키, 기기정보, 접속 로그, 방문 일시, 서비스 이용 기록, 불량 이용 기록, 결제 기록',
      ],
    ],
    lineBreak: true,
  },
  {
    discription1:
      '③ 회사는 회원탈퇴 및 회원자격 상실 후에도 다음에 해당할 경우 개인정보를 보유합니다.',
    lineBreak: true,
  },
  {
    discription1: '1)관계 법령에 의한 정보 보유 사유',
  },
  {
    table: {
      headers: [
        { title: '보존 근거 ' },
        { title: '구분' },
        { title: '보유 기간' },
      ],
      rows: [
        {
          cells: [
            {
              value: '전자상거래 등에서의 소비자보호에 관한 법률',
            },
            {
              value:
                '계약 또는 청약철회 등에 관한 기록(회원 식별정보, 계약•청약철회 기록 등)',
            },
            {
              value: '5년',
            },
          ],
        },
        {
          cells: [
            {
              value: '전자상거래 등에서의 소비자보호에 관한 법률',
            },
            {
              value:
                '대금결제 및 재화 등의 공급에 관한 기록(회원 식별정보, 계약•청약철회 기록 등)',
            },
            {
              value: '5년',
            },
          ],
        },
        {
          cells: [
            {
              value: '전자상거래 등에서의 소비자보호에 관한 법률',
            },
            {
              value: '소비자의 불만 및 분쟁처리에 관한 기록',
            },
            {
              value: '3년',
            },
          ],
        },
        {
          cells: [
            {
              value: '신용정보의 이용 및 보호에 관한 법률',
            },
            {
              value: '신용정보의 수집•처리 및 이용 등에 관한 기록',
            },
            {
              value: '3년',
            },
          ],
        },
        {
          cells: [
            {
              value: '국세기본법',
            },
            {
              value: '세법에 규정하는 모든 거래에 관한 장부 및 증빙서류',
            },
            {
              value: '5년',
            },
          ],
        },
        {
          cells: [
            {
              value: '통신비밀보호법',
            },
            {
              value: '웹 사이트 방문기록(로그기록, IP 등)',
            },
            {
              value: '3개월',
            },
          ],
        },
      ],
    },
    lineBreak: true,
  },
  {
    discription1: '2)내부 방침에 의한 보유',
    table: {
      headers: [
        { title: '보존 근거' },
        { title: '보유 항목' },
        { title: '보유 기간' },
      ],
      rows: [
        {
          cells: [
            {
              value: '회원탈퇴 후 재가입 방지',
            },
            {
              value: '암호화된 동일인 식별정보(CI), 중복가입 확인정보(DI)',
            },
            {
              value: '회원 탈퇴 후 3개월',
            },
          ],
        },
        {
          cells: [
            {
              value: '부정이용자 식별, 회원 자격 정지, 재발 방지',
            },
            {
              value:
                '암호화된 동일인 식별정보(CI), 면허번호, 악의적 서비스 이용 내역 및 제재 사유, 일자',
            },
            {
              value:
                '영구정지 사유 발생으로부터 10년 또는 해제 사유 발생 시까지',
            },
          ],
        },
      ],
    },
    lineBreak: true,
  },
  {
    discription1:
      '④ 서비스 제공을 위해 반드시 필요한 최소한의 정보를 필수항목으로, 그 외 특화된 서비스를 제공하기 위해 추가 수집하는 정보는 선택항목으로 동의를 받고 있으며, 선택항목에 동의하지 않은 경우에도 서비스 이용에 제한은 없습니다. 단, 서비스 특성에 따라 동의를 거부할 경우 해당 서비스 사용에 제약이 발생할 수 있습니다.',
    lineBreak: true,
  },
  {
    title1: '2. 14세 미만 아동의 개인정보 처리에 관한 사항',
    discription1:
      '회사는 법정대리인의 동의가 필요한 만 14세 미만 아동의 개인정보는 원칙적으로 수집하지 않으며, 따라서 14세 미만의 고객은 회원가입에 제한 됩니다.',
    lineBreak: true,
  },
  {
    title1: '3. 개인정보의 파기 절차 및 방법에 관한 사항',
    discription1:
      '회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관계법령에 따라 개인정보를 보존하여야 하는 경우에는 해당 기간 경과 후 지체없이 재생 불가능한 방법으로 파기하며, 회사의 개인정보 파기절차 및 방법은 다음과 같습니다.',
    lineBreak: true,
  },
  {
    discription1:
      '① 개인정보 파기절차\n' +
      '이용자가 입력한 정보는 수집 및 이용목적 달성 후 별도의 DB에 옮겨져(종이의 경우 별도의 서류함) 내부 규정 및 기타 관련 법령에 따라 일정기간 저장되거나 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의해 허용된 경우가 아니고서는 다른 목적으로 이용되지 않습니다.',
    lineBreak: true,
  },
  {
    discription1:
      '② 개인정보 파기기한\n' +
      '개인정보의 보유기간이 경과한 경우에는 그 경과한 날로부터, 개인정보의 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 된 경우에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 각 지체 없이(정당한 사유가 없는 한 영업일 기준 5일 이내) 해당 개인정보를 파기합니다.',
    lineBreak: true,
  },
  {
    discription1:
      '③ 개인정보 파기방법\n' +
      '전자적 파일 형태의 정보는 DB의 경우 Null•난수값 대체 방법, 저장장치의 경우 로우레벨포맷 등 복구 및 재생이 되지 않는 기술적인 방법을 사용합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.',
    lineBreak: true,
  },
  {
    title1: '4. 개인정보의 제 3자 제공에 관한 사항',
    discription1:
      '① 회사는 정보주체의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다',
    lineBreak: true,
  },
  {
    discription1:
      '② 회사는 원활한 서비스 제공을 위해 정보주체의 동의를 얻어 필요 최소한의 범위로 제공합니다.',
    lineBreak: true,
  },
  {
    table: {
      headers: [{ title: '개인정보 제3자 제공 현황', colSpan: 5 }],
      rows: [
        {
          cells: [
            {
              value: '서비스(구분)',
            },
            {
              value: '제공받는 자의 이용목적',
            },
            {
              value: '제공받는자',
            },
            {
              value: '제공 항목',
            },
            {
              value: '제공받는 자의 보유 및 이용기간',
            },
          ],
        },
        {
          cells: [
            {
              value: '-',
            },
            {
              value: '-',
            },
            {
              value: '-',
            },
            {
              value: '-',
            },
            {
              value: '-',
            },
          ],
        },
      ],
    },
    lineBreak: true,
  },
  {
    discription1:
      '③ 재난, 감염병, 급박한 생명, 신체 위험을 초래하는 사건사고, 급박한 재산손실 등의 긴급상황이 발생하는 경우, 정보주체의 동의 없이 관계기관에 개인정보를 제공할 수 있습니다.',
    lineBreak: true,
  },
  {
    table: {
      headers: [
        { title: '분류' },
        { title: '근거법령' },
        { title: '제공기관' },
        { title: '제공되는 개인정보' },
      ],
      rows: [
        {
          cells: [
            { value: '재난대응' },
            { value: '재난안전법 제74조의3 (정보제공 요청 등)' },
            { value: '중앙대책본부 또는 지역대책본부' },
            { value: '성명, 휴대전화번호 생년월일, 개인위치정보' },
          ],
        },
        {
          cells: [
            { value: '감염병의 예방 및 관리' },
            {
              value: '감염병예방법 제 76조의 2(정보 제공 요청 및 정보 확인 등)',
            },
            { value: '질병관리청 또는 전국 시 • 도' },
            { value: '성명, 휴대전화번호' },
          ],
        },
        {
          cells: [
            { value: '실종아동•정신장애인•치매 환자등 발견' },
            { value: '실종아동법 제9조(수색 또는 수사의 실시 등)' },
            { value: '경찰관서' },
            { value: '개인위치정보' },
          ],
        },
        {
          cells: [
            { value: '자살위험자 보호' },
            {
              value:
                '자살예방법 제19조의3(긴급구조대상자 구조를 위한 정보 제공요청 등)',
            },
            { value: '경찰관서 해양경찰 소방관서' },
            {
              value:
                '긴급구조대상자의 성명, 생년월일, 휴대전화번호, 아이디, 개인위치정보',
            },
          ],
        },
        {
          cells: [
            { value: '긴급 구조요청 등 대응' },
            {
              value: '위치정보법 제29조(긴급구조를 위한 개인 위치정보의 이용)',
            },
            { value: '소방관서' },
            { value: '개인위치정보' },
          ],
        },
        {
          cells: [
            { value: '납치,감금 등 범죄와 관련된 자의 개인정보처리' },
            {
              value:
                '개인정보보호법 제18조 제2항 제7호(개인정보의 목적 외 이용•제공 제한)',
            },
            { value: '경찰관' },
            { value: 'CCTV 등 영상정보' },
          ],
        },
      ],
    },
    lineBreak: true,
  },
  {
    title1: '5. 개인정보 처리업무의 위탁에 관한 사항',
    discription1:
      '① 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.\n' +
      '② 현재 재위탁 사항이 없습니다.\n' +
      '③ 회사는 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재 위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.\n' +
      '④ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.',
    table: {
      headers: [{ title: '개인정보 처리위탁 현황', colSpan: 3 }],
      rows: [
        {
          cells: [
            { value: '구분' },
            {
              value: '위탁받는자(수탁자)',
            },
            { value: '위탁업무' },
          ],
        },
        {
          cells: [
            { value: '-' },
            {
              value: '-',
            },
            { value: '-' },
          ],
        },
      ],
    },
    lineBreak: true,
  },
  {
    title1: '6. 개인정보 안정성 확보조치에 관한 사항',
    discription1:
      '회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.\n\n' +
      '① 관리적 조치 : 정기적인 자체 감사 실시, 개인정보 처리 직원의 최소화 및 교육, 내부관리계획의 수립 및 시행, 개인정보보호관리기구의 운영\n' +
      '② 기술적 조치 : 해킹 등에 대비한 대책, 개인정보의 암호화, 접속기록의 보관 및 위변조 방지, 개인정보처리시스템 접근 제한\n' +
      '③ 물리적 조치 : 문서보안을 위한 잠금장치 사용, 비인가자에 대한 출입 통제',
    lineBreak: true,
  },
  {
    title1: '7. 개인정보 자동 수집 장치의 설치・운영 및 그 거부에 관한 사항',
    discription1:
      '① 회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용 정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.\n' +
      '② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.\n' +
      '1) 쿠키의 사용목적: 이용자가 방문한 웹페이지 대한 방문 및 이용형태, 보안접속 여부 등을 파악하기 위해 사용합니다.\n' +
      '2) 쿠키의 설치·운영 및 거부 : 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.\n\n' +
      '※ 쿠키 설치 거부 방법',
    table: {
      headers: [{ title: '구분' }, { title: '경로' }],
      rows: [
        {
          cells: [
            { value: 'Microsoft Edge' },
            {
              value:
                '웹 브라우저 상단의 설정(단축키 Alt+F) > 쿠키 및 사이트 권한 > 쿠키 및 사이트 데이터 관리 및 삭제',
            },
          ],
        },
        {
          cells: [
            { value: 'Google Chrome' },
            {
              value:
                '웹 브라우저 오른쪽 상단의 설정 > 개인 정보 보호 및 보안 > 인터넷 사용 기록 삭제 > 쿠키 및 기타 사이트 데이터',
            },
          ],
        },
        {
          cells: [
            { value: 'Safari' },
            {
              value:
                '웹 브라우저 상단 좌측 메뉴바 > 설정 > 개인정보 보호 > 웹 사이트 데이터 관리',
            },
          ],
        },
        {
          cells: [
            { value: 'Firefox' },
            {
              value:
                '웹 브라우저 메뉴 버튼 > 설정 > 개인 정보 및 보안 > 쿠키 및 사이트 데이터 관리 > 데이터 관리',
            },
          ],
        },
        {
          cells: [
            { value: 'Android' },
            {
              value: '추후 별도 안내',
            },
          ],
        },
        {
          cells: [
            { value: 'IOS' },
            {
              value: '추후 별도 안내',
            },
          ],
        },
      ],
    },
    lineBreak: true,
  },
  {
    title1: '8. 행태정보의 수집·이용 및 거부에 관한 사항',
    discription1:
      '① 회사는 서비스 이용과정에서 정보주체에게 최적화된 맞춤형 서비스 및 혜택, 온라인 맞춤형 광고 등을 제공하기 위하여 쿠키 등을 활용하여 행태정보를 수집·이용하고 있습니다.\n' +
      '② 행태정보란 웹 사이트 방문이력, 앱 사용 이력, 구매 및 검색 이력 등 이용자의 관심, 흥미, 기호 및 성향등을 파악하고 분석할 수 있는 온라인상의 이용자 활동정보를 말합니다.\n' +
      '1) 회사는 다음과 같이 온라인 맞춤형 광고 사업자가 행태정보를 수집하도록 허용하고 있습니다.',
    discription2: [
      [
        '●',
        '행태정보를 수집 및 처리하려는 광고 사업자 : Google, Facebook, AppsFlyer, Branch, amplitude',
      ],
      [
        '●',
        '행태정보 수집 방법 : 이용자가 당사 웹사이트를 방문하거나 앱을 실행할 때 자동 수집 및 전송',
      ],
      [
        '●',
        '수집 · 처리되는 행태정보 항목 : 이용자의 웹/앱 방문이력, 검색이력, 구매이력',
      ],
    ],
    lineBreak: true,
  },
  {
    discription1: '※ 모바일 단말기의 광고식별자 차단방법',
    table: {
      headers: [{ title: '구분' }, { title: '경로' }],
      rows: [
        {
          cells: [
            { value: 'IOS' },
            {
              value: '추후 별도 안내',
            },
          ],
        },
        {
          cells: [
            { value: 'Android' },
            {
              value: '추후 별도 안내',
            },
          ],
        },
      ],
    },
    lineBreak: true,
  },
  {
    title1: '9. 이용자의 권리와 그 행사방법',
    discription1:
      '① 이용자는 언제든지 등록되어 있는 이용자의 개인정보를 열람하거나 수정할 수 있으며, 자신의 개인정보에 대한 열람을 요청할 수 있습니다.\n' +
      '1) 개인정보 처리 방법에 관한 고시(제2023-12호)” 별지 제 8호 서식에 따른 개인정보 열람 요구서 제출\n\n' +
      '② 이용자는 언제든지 개인정보 처리의 정지를 요청할 수 있으며, 법률에 특별한 규정이 있는 등의 경우에는 처리정지 요청을 거부할 수 있습니다.\n\n' +
      `③ 이용자는 언제든지 '회원 탈퇴하기' 화면을 통해 본인확인 절차를 거친 후 개인정보의 수집 및 이용 동의를 철회할 수 있습니다.\n\n` +
      '④ 이용자가 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 해당 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 하겠습니다.\n\n' +
      '⑤ 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는 제3조에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.\n\n' +
      `⑥ 이용자의 권리는 '설정' 화면에서 직접 처리가 가능합니다. 다만, 직접 처리가 불가능한 건은 개인정보 보호 업무 담당부서에게 서면, 전화 또는 이메일로 요청하시면 관계법령에 따른 기간 내 권리행사 방법 또는 그 결과를 통지하겠습니다.\n\n` +
      '⑦ 동 조에 따른 이용자의 권리를 대리하고자 할 경우 이용자로부터 위임을 받고서 이용자의 위임장을 회사에 제출하여야 합니다.\n' +
      '1) “개인정보 처리 방법에 관한 고시(제2023-12호)” 별지 제11호 서식에 따른 위임장 제출\n' +
      '2) 정보주체와 대리인 사이의 대리관계를 증명할 수 있는 서면(주민등록등본, 가족관계증명서 등) 제출\n',
    lineBreak: true,
  },
  {
    title1: '10. 개인정보 보호책임자 및 담당부서',
    table: {
      headers: [
        { title: '성명' },
        { title: '직책' },
        { title: '이메일' },
        { title: '소속' },
      ],
      rows: [
        {
          cells: [
            { value: '오채윤' },
            {
              value: '팀장',
            },
            {
              value: 'pm@adrock.me',
            },
            {
              value: '사업전략팀',
            },
          ],
        },
      ],
    },
  },
  {
    discription1:
      '이용자는 서비스를 이용하시면서 발생한 모든 개인정보보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다. 회사는 이용자의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.',
    lineBreak: true,
  },
  {
    title1: '11. 개인위치정보의 처리',
    discription1:
      '회사는 위치정보의 보호 및 이용 등에 관한 법률에 따라 다음과 같이 이용자의 개인위치정보를 안전하게 관리합니다.',
  },
  {
    discription1: '① 개인위치정보의 처리 목적과 보유 기간',
  },
  {
    table: {
      headers: [
        { title: '운영 근거' },
        { title: '서비스' },
        { title: '수집∙이용 목적' },
        { title: '보유 및 이용기간' },
      ],
      rows: [
        {
          cells: [
            {
              value:
                '위치정보의 보호 및 이용 등에 관한법 제 16조 제 2항(위치정보의 보호조치 등)',
              rowSpan: 2,
            },
            {
              value: '도로로(하위부가서비스 공통)',
              rowSpan: 2,
            },
            {
              value:
                '개인위치정보주체의 현 위치를 이용하여 주변 서비스 이용 매장 및 강사 검색 결과 제공',
            },
            {
              value: '이용 목적 달성 시 까지',
              rowSpan: 2,
            },
          ],
        },
        {
          cells: [
            {
              value:
                '개인위치정보주체가 대여한 차량의 위치를 이용하여 차량 반납 위치 변경 및 이상여부 확인',
            },
          ],
        },
      ],
    },
  },
  {
    discription1:
      '※ 회사는 위치정보 서비스 및 기반서비스 제공을 위하여 개인위치정보를 일회성 또는 임시로 이용 후 지체없이 파기하고 있습니다. 다만, 서비스 제공을 위하여 개인위치정보의 보관이 불가피할 경우 이용목적 달성 시 지체없이 파기하고 있습니다.',
    lineBreak: true,
  },
  {
    discription1:
      '② 개인위치정보 수집ㆍ이용ㆍ제공사실 확인자료의 보유근거 및 보유기간\n' +
      '회사는 위치정보의 보호 및 이용 등에 관한 법률 제16조제2항에 따라 개인위치정보 수집‧이용‧제공사실 확인자료를 자동으로 기록·보존하며, 해당 자료는 기록시점으로부터 최소 6개월간 보존합니다.',
    lineBreak: true,
  },
  {
    discription1:
      '③ 개인위치정보의 파기 절차 및 방법\n' +
      '회사는 회원탈퇴 등 처리목적이 달성되거나 보유기간이 경과하면 복구 및 재생이 불가능한 방법으로 지체없이 파기하며, 파기 절차와 그 방법은 제5조에서 고지한 내용을 따릅니다.',
    lineBreak: true,
  },
  {
    discription1:
      '④ 개인위치정보의 제3자 제공 및 통보에 관한 사항\n' +
      '회사는 이용자의 사전 동의 없이 개인위치정보를 제3자에게 제공하지 않습니다. 단, 이용자가 개인위치정보 제공에 직접 동의를 한 경우, 관련 법령에 의거해 관련 기관에 제출 의무가 발생한 경우, 이용자의 생명이나 안전에 급박한 위험이 확인되어 이를 해소하기 위한 경우에 한하여 개인위치정보를 제공합니다. 회사는 개인위치정보를 이용자가 지정한 제3자에게 제공하는 경우, 제공받는 자, 제공일시 및 제공목적을 이용자에게 전자우편 또는 팝업 등의 고지로 즉시 통보합니다.',
    lineBreak: true,
  },
  {
    discription1:
      '⑤ 보호의무자 권리·의무 및 그 행사방법에 관한 사항\n' +
      '회사는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동 등")의 위치정보의 보호 및 이용 등에 관한 법률 제26조제2항에 따른 보호의무자에 해당하는 자(이하 “보호의무자”)가 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.',
    lineBreak: true,
  },
  {
    discription2: [
      ['1)', '8세 이하의 아동'],
      ['2)', '피성년후견인'],
      [
        '3)',
        '장애인복지법 제2조제2항제2호에 따른 정신적 장애를 가진 사람으로서 장애인고용촉진 및 직업재활법 제2조제2호에 따른 중증장애인에 해당하는 사람(장애인복지법 제32조에 따라 장애인 등록을 한 사람만 해당한다.) 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의하고자 하는 보호의무자는 서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 하며, 보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 위치정보 이용약관 상의 이용자의 권리를 모두 가집니다.',
      ],
    ],
    lineBreak: true,
  },
  {
    title1: '12. 정보주체의 권익침해에 대한 구제방법',
    discription1:
      '정보주체는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.',
    table: {
      headers: [
        { title: '기관명' },
        { title: '기관 URL / 연락처' },
        { title: '소관 업무' },
      ],
      rows: [
        {
          cells: [
            { value: '개인정보 침해신고센터' },
            { value: 'privacy.kisa.or.kr\n(국번없이) 118' },
            { value: '개인정보 침해사실 신고, 상담신청' },
          ],
        },
        {
          cells: [
            { value: '개인정보 분쟁조정위원회' },
            { value: 'www.kopico.go.kr\n(국번없이) 1833-6972' },
            { value: '개인정보 분쟁조정신청, 집단분쟁조정(민사적 해결)' },
          ],
        },
        {
          cells: [
            { value: '대검찰청 사이버수사과' },
            { value: 'www.spo.go.kr\n(국번없이) 1301' },
            { value: '사이버범죄 사건 수사 진행' },
          ],
        },
        {
          cells: [
            { value: '경찰청 사이버수사국' },
            { value: 'ecrm.cyber.go.kr\n(국번없이) 182' },
            {
              value:
                '사이버범죄 사건 수사 진행(해킹,사기,불법사이트 등 형사처벌 대상)',
            },
          ],
        },
      ],
    },
    lineBreak: true,
  },
  {
    title1: '13. 개인정보 처리방침의 변경',
    discription1:
      '본 개인정보처리방침 개정 시에는 ‘홈페이지’를 통해 사전 고지합니다. 단, 제공, 위탁 또는 국외 이전에 대한 변경의 경우는 고지 즉시 개정될 것입니다. 현재 효력을 발생하는 본 방침의 공고일자와 시행일자, 이전 개인정보처리방침은 아래와 같습니다.\n\n' +
      '- 공고일자 : 2025년 1월 24일',
    lineBreak: true,
  },
];
